import { __exports as o } from "./index120.js";
import { __require as d } from "./index115.js";
import { __require as v } from "./index88.js";
import { __require as y } from "./index92.js";
import { __require as l } from "./index117.js";
var s;
function j() {
  if (s) return o;
  s = 1;
  var p = o && o.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(o, "__esModule", { value: !0 }), o.Page = void 0;
  var h = p(d()), a = v(), m = y(), _ = p(l());
  function n(r, e) {
    a.Facade.call(this, r, e);
  }
  o.Page = n, h.default(n, a.Facade);
  var t = n.prototype;
  return t.action = function() {
    return "page";
  }, t.type = t.action, t.category = a.Facade.field("category"), t.name = a.Facade.field("name"), t.title = a.Facade.proxy("properties.title"), t.path = a.Facade.proxy("properties.path"), t.url = a.Facade.proxy("properties.url"), t.referrer = function() {
    return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
  }, t.properties = function(r) {
    var e = this.field("properties") || {}, u = this.category(), c = this.name();
    r = r || {}, u && (e.category = u), c && (e.name = c);
    for (var i in r)
      if (Object.prototype.hasOwnProperty.call(r, i)) {
        var f = this[i] == null ? this.proxy("properties." + i) : this[i]();
        if (f == null)
          continue;
        e[r[i]] = f, i !== r[i] && delete e[i];
      }
    return e;
  }, t.email = function() {
    var r = this.proxy("context.traits.email") || this.proxy("properties.email");
    if (r)
      return r;
    var e = this.userId();
    if (_.default(e))
      return e;
  }, t.fullName = function() {
    var r = this.category(), e = this.name();
    return e && r ? r + " " + e : e;
  }, t.event = function(r) {
    return r ? "Viewed " + r + " Page" : "Loaded a Page";
  }, t.track = function(r) {
    var e = this.json();
    return e.event = this.event(r), e.timestamp = this.timestamp(), e.properties = this.properties(), new m.Track(e, this.opts);
  }, o;
}
export {
  j as __require
};
//# sourceMappingURL=index93.js.map
